import { FormattedMessage } from 'react-intl'
import { faClock } from '@fortawesome/pro-solid-svg-icons'

import { Heading } from 'Components/_theme/Heading/Heading'
import { PrimaryButton } from 'Components/_theme/PrimaryButton/PrimaryButton'
import { Icon } from 'Components/Icon/Icon'

import type { PortalReturnLabelModalComingSoonProps } from './PortalReturnLabelModal.types'

export const PortalReturnLabelModalComingSoon = (
  props: PortalReturnLabelModalComingSoonProps,
) => {
  const { onClose } = props

  return (
    <div aria-live="polite" className="text-center" role="status">
      <div className="text-primary d-flex justify-content-center mb-5">
        <Icon icon={faClock} size={48} />
      </div>

      <Heading as={4} className="mb-3" size={4}>
        <FormattedMessage id="PublicRequestReturnLabel_labelComingSoon_heading" />
      </Heading>

      <p className="text-muted mb-5">
        <FormattedMessage id="PublicRequestReturnLabel_labelComingSoon_body" />
      </p>

      <PrimaryButton onClick={onClose}>
        <FormattedMessage id="Close" />
      </PrimaryButton>
    </div>
  )
}
